import React from 'react';
import { ReserveJudge } from '../../../../../api/responses';
import { JudgesNameWrapper, JudgesTitleWrapper, JudgesWrapper } from './styles';

type JudgesProps = {
  judges: ReserveJudge | ReserveJudge[];
  lang: string;
};

const ReservedJudges = ({ judges, lang = 'ru' }: JudgesProps) => {
  const reserveJudges = Array.isArray(judges) ? judges : [judges];

  const formatReserveJudgesNames = () =>
    reserveJudges
      .map((judge) => `${judge.last_name} ${judge.first_name}`)
      .join(', ');

  return (
    <JudgesWrapper>
      <JudgesTitleWrapper>
        {reserveJudges.length === 1
          ? `${lang === 'ru' ? 'РЕЗЕРВНЫЙ СУДЬЯ' : 'RESERVE VOTER'}: `
          : `${lang === 'ru' ? 'РЕЗЕРВНЫЕ СУДЬИ' : 'RESERVE VOTERS'}: `}
      </JudgesTitleWrapper>
      <JudgesNameWrapper>{formatReserveJudgesNames()}</JudgesNameWrapper>
    </JudgesWrapper>
  );
};

export default ReservedJudges;
